<template>
  <div class="mb-2 p-2 text-center small d-flex align-items-center pagination-bar">
    <button type="button" @click="nextPage(-1)" class="btn btn-sm btn-outline-secondary me-auto" :disabled="prevDisabled" title="Previous Page">
      <span class="bi bi-chevron-left"></span>
    </button>
    <div class="mx-3 small">{{ startItem }}–{{ endItem }} of {{ totalItems }}</div>
    <button type="button" @click="nextPage(1)" class="btn btn-sm btn-outline-secondary  ms-auto" :disabled="nextDisabled" title="Next Page">
      <span class="bi bi-chevron-right"></span>
    </button>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue"
const props = defineProps({
  page: {
    type: Number,
    required: true,
    default: () => 1
  },
  perPage: {
    type: Number,
    required: true,
    default: () => 15
  },
  totalItems: {
    type: Number,
    required: true,
    default: () => 0
  },
  smooth: {
    type: Boolean,
    default: true
  },
  variant: {
    type: String,
    default: 'bottom' // 'top' | 'bottom'
  }
})
//const propRef = toRef(props, 'pages')
const emits = defineEmits(['nextPage'])
const variantDisabled = computed(() => {
  return props.totalItems <= 0 || (props.variant === 'top' && props.perPage < 25)
})
const prevDisabled = computed(() => props.page <= 1 || variantDisabled.value )
const nextDisabled = computed(() => props.page >= Math.ceil(props.totalItems / props.perPage) || variantDisabled.value)

const startItem = computed(() => {
  if (props.totalItems === 0) return 0
  return (props.page - 1) * props.perPage + 1
})

const endItem = computed(() => {
  if (props.totalItems === 0) return 0
  return Math.min(props.page * props.perPage, props.totalItems)
})

function nextPage(dir) {
  emits('nextPage', dir)
  window.scrollTo({
    top: 0,
    behavior: props.smooth ? 'smooth' : 'instant'
  });
}
</script>

<style lang="scss" scoped>
.pagination-bar {
  *[disabled] {opacity: 0 !important;}
}
</style>
